import { render, staticRenderFns } from "./EmpresaRH.vue?vue&type=template&id=743f0cce"
import script from "./EmpresaRH.vue?vue&type=script&lang=js"
export * from "./EmpresaRH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports